<script setup>
import {onBeforeMount, onMounted, reactive, ref} from 'vue'
import BoxUpload from "@/components/YTBoxUpload/index.vue"
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import {addServiceItem, editServiceItem, listServiceItemDetail} from "@/api/serviceItem/serviceItem.js";
import {itemList} from "@/api/goods/goods.js";
import {disabledEndDate} from "@/hooks/dateUtils.js";
import YTEditor from "@/components/YTEditor/index.vue";

const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.serviceItemId)
  await handleGetBizList()
  if (isEdit.value) {
    await getDetail(route.query.serviceItemId)
  } else {
    // addOperatingTime()
  }
})
/*获取商店信息*/
const getDetail = async (serviceItemId) => {
  loading.value = true
  try {
    const res = await listServiceItemDetail(serviceItemId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    console.log("ruleForm", ruleForm)
    if (res.coverImage !== '[]') handleReview([res.coverImage])
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此服务项目数据",
        duration: 3000,
        onClose: () => {
          router.push("/listServiceItems")
        }
      })
    }
  }
}
/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 上传组件锚点
const boxUploadRef = ref()
// 表单信息
const ruleForm = reactive({
  name: null,
  nameEn: "Coming Soon ...",
  type: null,
  coverImage: [],
  startTime: null,
  endTime: null,
  intro: null,
  introEn: "Coming Soon ...",
  introImages: [],
  introEnImages: [],
  bizType: "COMPETITION",
  bizId: null,
  bizName: null,
  chargeType: "HOUR",
  price: 0,
  vipPrice: 0
})
// 校验表单 - 照片列表
const checkCoverImage = (rule, value, callback) => {
  if(boxUploadRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张照片'))
  callback()
}
// 服务日期校验规则
const checkServiceDate = (rule, value, callback) => {
  if (!ruleForm.startTime) {
    return callback(new Error("请选择服务开始日期"))
  }
  if (!ruleForm.endTime) {
    return callback(new Error("请选择服务结束日期"))
  }
  return callback()
}
// 名称校验规则
const checkName = (rule, value, callback) => {
  if (!ruleForm.name) {
    return callback(new Error("名称（中文）不能为空！"))
  }
  if (!ruleForm.nameEn) {
    return callback(new Error("名称（English）不能为空！"))
  }
  return callback()
}
// 商品推荐校验规则
const checkDescription = (rule, value, callback) => {
  if (ruleForm.intro && !ruleForm.introEn) {
    return callback(new Error("商品推荐（English）不能为空！"))
  }
  return callback()
}
// 服务项目校验规则
const checkItem = (rule, value, callback) => {
  if (!ruleForm.bizType) {
    return callback(new Error("请选择关联项目类型"))
  }
  if (!ruleForm.bizId) {
    return callback(new Error("请选择关联的具体项目"))
  }
  return callback()
}
// 服务收费校验规则
const checkPrice = (rule, value, callback) => {
  if (ruleForm.price < 0 || ruleForm.price === null || ruleForm.price === "") {
    return callback(new Error("请输入服务收费金额"))
  }
  if (!ruleForm.chargeType) {
    return callback(new Error("请选择服务收费单位"))
  }
  return callback()
}
// VIP价校验规则
const checkVipPrice = (rule, value, callback) => {
  if (ruleForm.vipPrice < 0 || ruleForm.vipPrice === null || ruleForm.vipPrice === "") {
    return callback(new Error("请输入VIP价"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  name: [
    {required: true, validator: checkName, trigger: 'blur'},
  ],
  type: [
    {required: true, message: "请选择类型", trigger: "change"}
  ],
  // coverImage: [
  //   {required: true, validator: checkCoverImage, trigger: 'blur'}
  // ],
  serviceDate: [
    {required: true, validator: checkServiceDate, trigger: 'blur'}
  ],
  item: [
    {required: true, validator: checkItem, trigger: 'change'}
  ],
  price: [
    {required: true, validator: checkPrice, trigger: 'change'}
  ],
  vipPrice: [
    {required: true, validator: checkVipPrice, trigger: 'change'}
  ],
  intro: [
    {validator: checkDescription, trigger: 'blur'}
  ]
})
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      const res = await handleRich2Form()
      if (!res) throw new Errow("商品描述（中文）富文本描述过长")
      const res2 = await handleRich2FormEn()
      if (!res2) throw new Errow("商品描述（English）富文本描述过长")
      ruleForm.introImages = YTEditorRef.value.getImagesUrlArr()
      ruleForm.introEnImages = YTEditorEnRef.value.getImagesUrlArr()
      await createServiceItem()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 项目类型枚举
const typeEnum = [
  {
    label: "理疗",
    value: "THERAPY"
  },
  {
    label: "摄影摄像",
    value: "PHOTOGRAPHY"
  }
]
// 关联项目类型枚举
const itemTypeEnum = [
  {
    label: "赛事",
    value: "COMPETITION",
  }
]
// 赛事列表
const bizItemList = ref([])
// 创建门店
const createServiceItem = async () => {
  console.log("ruleForm:", ruleForm)
  try {
    if (isEdit.value) {
      await editServiceItem(ruleForm)
    } else {
      await addServiceItem(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listServiceItems')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}

// 处理图片上传成功
const handlePicSuccess = (url) => {
  ruleForm.coverImage = []
  ruleForm.coverImage = url
  loading.value = false
}
// 处理图片反显
const handleReview = (reviewList) => {
  console.log("father handleReview", reviewList)
  boxUploadRef.value.handleReview(reviewList)
}
// 处理删除图片
const handlePicRemove = (url) => {
  ruleForm.coverImage = url
}
// 服务收费单位枚举
const unitEnum = [
  {
    label: "分钟",
    value: "MINUTE"
  },
  {
    label: "小时",
    value: "HOUR"
  },
  {
    label: "天",
    value: "DAY"
  }
]
// 关联项目相关选项列表加载状态
const bizLoading = ref(false)
// 处理关联项目赛事选择
const handleBizChange = async (e) => {
  const target = bizItemList.value.find(item => item.goodsId === e)
  ruleForm.bizName = target.goodsName
}
// 处理关联项目类型改变
const handleBizTypeChange = async () => {
  ruleForm.bizId = null
  ruleForm.bizName = null
  await handleGetBizList()
}
// 获取关联项目相关选项列表
const handleGetBizList = async (key) => {
  if (ruleForm.bizType === "COMPETITION") {
    await handleGetCompetitionList(key)
  }
}
// 获取赛事商品列表
const handleGetCompetitionList = async (key) => {
  try {
    bizLoading.value = true
    const param = ref({
      page: 1,
      pageSize: 100
    })
    const res = await itemList(param.value, {categoryType: "COMPETITION",  keyword: key ? key : null});
    bizItemList.value = res.list
    bizLoading.value = false
  } catch (e) {
    console.log(e)
    bizLoading.value = false
  }
}

/*富文本相关*/
// 描述（中文）富文本锚点
const YTEditorRef = ref()
// 描述（English）富文本锚点
const YTEditorEnRef = ref()
// 处理商品描述（中文）富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState())
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("描述（中文）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.intro = YTEditorRef.value.getTxt()
  return true
}
// 处理商品描述（English）富文本赋值给表单
const handleRich2FormEn = async () => {
  console.log("赋值结果", YTEditorEnRef.value.getTxtTooLongState())
  if (YTEditorEnRef.value.getTxtTooLongState()) {
    ElMessage.error("描述（English）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.introEn = YTEditorEnRef.value.getTxt()
  return true
}


/*中英文切换输入框相关Tab*/
// 名称tab
const nameTab = ref("zh")
// 描述tab
const introTab = ref("zh")
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="名称：" prop="name">
          <el-tabs
              v-model="nameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.name" maxlength="30" placeholder="名称最长30个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.nameEn" maxlength="90" placeholder="The name should be up to 90 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="类型：" prop="type" style="width: 250px;">
          <el-select v-model="ruleForm.type" placeholder="请选择" :disabled="false">
            <el-option
                v-for="item in typeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题图片：" prop="coverImage">
          <BoxUpload ref="boxUploadRef" :aliOssPath="'SERVICE_ITEM'" :width="900" :height="400" :limit="1" :size="1" @progress="loading = true" @success="handlePicSuccess" @remove="handlePicRemove"/>
        </el-form-item>
        <el-form-item label="服务日期：" prop="serviceDate">
          <div class="flex_left">
            <el-date-picker
                v-model="ruleForm.startTime"
                type="date"
                placeholder="开始日期"
                class="mg_r_1"
                @change="() => ruleForm.endTime = null"
            />
            <div class="mg_r_1">至</div>
            <el-date-picker
                v-model="ruleForm.endTime"
                type="date"
                placeholder="结束日期"
                :disabled-date="
                  (time) => disabledEndDate(time, ruleForm.startTime)
                "
            />
          </div>
        </el-form-item>
        <el-form-item label="关联项目：" prop="item">
          <div class="flex W-100">
            <el-select @change="handleBizTypeChange" class="mg_r_1" :disabled="true" v-model="ruleForm.bizType" style="width: 150px;" placeholder="请选择">
              <el-option
                  v-for="item in itemTypeEnum"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select class="mg_r_1" remote-show-suffix filterable remote :remote-method="handleGetBizList" :loading="bizLoading" v-model="ruleForm.bizId" style="width: 250px;" placeholder="请选择" @change="handleBizChange">
              <el-option
                  v-for="item in bizItemList"
                  :key="item.goodsId"
                  :label="item.goodsName"
                  :value="item.goodsId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="服务收费：" label-position="top" style="text-align: left; margin-left: 10px;">
          <div>
            <el-form-item label="原价" prop="price" style="margin-bottom: 10px;">
              <el-input-number v-model="ruleForm.price" class="mg_r_1" :min="0" :precision="2"></el-input-number>
              <el-select
                  v-model="ruleForm.chargeType"
                  placeholder="收费单位"
                  size="large"
                  style="width: 120px"
                  class="mg_r_2"
                  :disabled="true">
                <el-option
                  v-for="(opt, optIndex) in unitEnum"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="VIP价" prop="vipPrice">
              <el-input-number v-model="ruleForm.vipPrice" class="mg_r_1" :min="0" :precision="2"></el-input-number>
              <el-select
                  v-model="ruleForm.chargeType"
                  placeholder="收费单位"
                  size="large"
                  style="width: 120px"
                  class="mg_r_2"
                  :disabled="true">
                <el-option
                  v-for="(opt, optIndex) in unitEnum"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="描述：" prop="intro">
          <el-tabs
              v-model="introTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <YTEditor :ali-oss-path="'SERVICE_ITEM_INTRO'" ref="YTEditorRef" :max-pic-size="3" :title="'描述（中文）'" :maxLength="2000" :reviewTxt="ruleForm.intro"></YTEditor>
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <YTEditor :ali-oss-path="'SERVICE_ITEM_INTRO'" ref="YTEditorEnRef" :max-pic-size="3" :title="'描述（English）'" :maxLength="6000" :reviewTxt="ruleForm.introEn"/>
            </el-tab-pane>
          </el-tabs>

        </el-form-item>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn @click="resetForm">取消</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </el-form>
    </v-container>
  </div>
</template>

<style scoped>

</style>
